<style lang="scss" scoped>
  .DrawerHeader {
    &__header {
      border: none;

      &-button {
        float: left;
        margin-top: 24px;
        margin-left: 20px;
        text-align: center;
        background-color: #ffffff;
        border: none;
      }

      &-back-arrow {
        float: left;
        margin-top: 2px;
        /*      margin-left: 20px;*/
      }

      &-back-text {
        font-size: 12px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.4px;
        color: #202020;
        float: left;
        /*      margin-top: 22px;*/
        margin-left: 10px;
      }
    }

    &__toggle-btn {
      padding: 0;
      width: 59px;
      height: 60px;
      position: absolute;
      left: 330px;
      background-image: linear-gradient(45deg, #ff5000, #ed8a16);
      text-align: center;

      @media only screen and (max-width: 1000px) {
        left: 211px;
      }
    }
    &__arrowImg {
      display: block;
      width: 13px;
      height: 20px;
      margin-left: 23px;
    }
  }
</style>

<template lang="pug">
  .DrawerHeader
    header.DrawerHeader__header(v-show="!hideHeader")
      span(@click="resetARElementinEdit")
        router-link.DrawerHeader__header-button(:to="backLink")
          img.DrawerHeader__header-back-arrow(src="@/assets/img/drawer-back-arrow.png")
          span.DrawerHeader__header-back-text {{title}}
    button.DrawerHeader__toggle-btn(v-show="!hideToggleButton", @click="toggleSidebar")
      img.DrawerHeader__arrowImg(v-if='closed' src="@/assets/img/arrow-close.png")
      img.DrawerHeader__arrowImg(v-else='closed' src="@/assets/img/arrow-open.png")
</template>

<script>
  import { mapMutations } from 'vuex';

  export default {
    name: 'DrawerHeader',

    props: {
      title: String,

      hideToggleButton: {
        type: Boolean,
        default: false,
      },

      hideHeader: {
        type: Boolean,
        default: false,
      },

      closed: {
        type: Boolean,
        default: false,
      },

      backLink: {
        type: String,
        default: '/',
      },
    },

    methods: {
      ...mapMutations('Firebase', ['resetAREleminEdit']),
      toggleSidebar() {
        this.$emit('toggle');
      },
      resetARElementinEdit() {
        // Rest the values of the ARElem in Edit when
        this.resetAREleminEdit();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/AppDrawer/components/DrawerHeader.vue